import { useMutation, useQuery } from '@tanstack/react-query';
import type { AssetCreateFormValues, ProductionEditorContextResponse } from './types';

export const QUERY_KEYS = {
  context: ['production-asset-create', 'context'] as const,
};

export function useProductionEditorContext() {
  return useQuery({
    queryKey: QUERY_KEYS.context,
    queryFn: async () => {
      const response = await fetch('/api/production-editor/context');
      if (!response.ok) {
        throw new Error("Impossible de charger le contexte de l'éditeur.");
      }
      return response.json() as Promise<ProductionEditorContextResponse>;
    },
  });
}

export function useCreateAsset() {
  return useMutation({
    mutationFn: async (values: AssetCreateFormValues) => {
      // Pas d'appel réseau réel — on simule un délai pour le feedback UI.
      await new Promise((resolve) => setTimeout(resolve, 600));
      return { id: `asset-${Date.now()}`, ...values };
    },
  });
}
